import { createSlice } from '@reduxjs/toolkit';
import { set } from 'lodash';

export const ImageGallerySlice = createSlice({
    name: "imagegalleryslice",
    initialState: {
        multiSelection: false,
        showImageGallery:true,
        imageNameUnderSearch:'',
        selectedImage:'---',
        selectedImagePath:'',
        selectedImageId:-1,
        integratedImage:'',
        linkAssetOption:true,
        imageType:'CUSTOMER',
        uploadedAssetObj:{
          assetid:-1
        },
        assetList:[],
        selectedAssetIdList:'', // Array of selected image objects
        holderHeight:'52vh',
      },
    reducers: {
      setShowImageGallery : (state, action) =>{
          state.showImageGallery = action.payload;
      },
      setUploadedAssetObj : (state, action) => {
        state.uploadedAssetObj.uploadedAssetObj=action.payload
      },
      setImageNameUnderSearch: (state, action) => {
        state.imageNameUnderSearch=action.payload;
      },
      setSelectedImage: (state, action) =>{
        state.selectedImage = action.payload.name;
        state.selectedImagePath=action.payload.path;
        state.selectedImageId = action.payload.id ? action.payload.id : -1;
      },
      setIntegratedImage: (state, action) =>{
        state.integratedImage = action.payload;
      },
      setLinkAssetOption: (state, action) =>{
        state.linkAssetOption = action.payload;
      },
      setImageType: (state, action) =>{
        state.imageType = action.payload;
      },
      setAssetList: (state, action) =>{
        state.assetList = action.payload;
      },
      setSelectedAssetIdList: (state, action) => {
        state.selectedAssetIdList = action.payload;
      },
      setMultiSelection: (state, action) => {
        state.multiSelection = action.payload;
      },
      
      setHolderHeight: (state, action) => {
        state.holderHeight = action.payload;
      },
    }
});
export const { setHolderHeight, setMultiSelection, setSelectedAssetIdList, setShowImageGallery, setUploadedAssetObj,setImageNameUnderSearch,setSelectedImage,setIntegratedImage, setLinkAssetOption, setImageType, setAssetList} = ImageGallerySlice.actions;
export default ImageGallerySlice.reducer;